import { defineStore } from 'pinia';
import { IApiVersion } from '@/interfaces/IApiVersion';
import { IAppVersion } from '@/interfaces/IAppVersion';

export const useVersionStore = defineStore('version', {
  state: () => ({
    apiVersions: [] as IApiVersion[],
    appVersion: {} as IAppVersion,
  }),
  getters: {
    hasApiError(): boolean {
      return this.apiVersions.some((v) => !v.isSuccess);
    },
    hasApiDevelopment(): boolean {
      return this.apiVersions.some((v) => v.environment === 'Development');
    },
    hasApiStaging(): boolean {
      return this.apiVersions.some((v) => v.environment === 'Staging');
    },
    hasApiLive(): boolean {
      return this.apiVersions.some((v) => v.environment === 'Live');
    },
  },

  actions: {
    addAppVersion(appVersion: IAppVersion) {
      this.appVersion = appVersion;
    },

    addApiVersion(name: string) {
      const newVersion: IApiVersion = {
        title: name,
        name,
        version: '',
        lastUpdated: '',
        environment: '',
        releaseSignature: '',
        lastFetched: new Date(),
        isLoading: true,
        isSuccess: true,
      };
      this.apiVersions.push(newVersion);
    },

    updateApiVersion(apiVersion: IApiVersion) {
      const versionIndex = this.apiVersions.findIndex(
        (v) => v.name === apiVersion.name
      );
      if (versionIndex > -1) {
        this.apiVersions[versionIndex] = apiVersion;
      }
    },

    setVersionLoading(name: string, isLoading: boolean) {
      const versionIndex = this.apiVersions.findIndex((v) => v.name === name);
      if (versionIndex > -1) {
        this.apiVersions[versionIndex].isLoading = isLoading;
      }
    },
  },
});
